import styled from 'styled-components';

const WithStyle = (ComponentName) => styled(ComponentName)`
  margin: 4px 6px 4px;
`;

export { WithStyle };
